import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessMetricsListRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('metric');
  }
}

export default instrumentRoutePerformance(BusinessMetricsListRoute);
